import { render, staticRenderFns } from "./add-cert.vue?vue&type=template&id=4d2f2dd7&scoped=true&"
import script from "./add-cert.vue?vue&type=script&lang=js&"
export * from "./add-cert.vue?vue&type=script&lang=js&"
import style0 from "./add-cert.vue?vue&type=style&index=0&id=4d2f2dd7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2f2dd7",
  null
  
)

export default component.exports